import { getCachedPlatform, isTauriRuntime, resolvePlatform } from "./platform";

async function androidClipboard(): Promise<boolean> {
  if (!isTauriRuntime()) return false;
  const platform = getCachedPlatform() === "unknown" ? await resolvePlatform() : getCachedPlatform();
  return platform === "android";
}

/** Only call from explicit user actions. No listener or background polling. */
export async function readClipboardText(): Promise<string> {
  if (await androidClipboard()) {
    const { invoke } = await import("@tauri-apps/api/core");
    return await invoke<string>("plugin:clipboard-manager|read_text");
  }
  if (!navigator.clipboard?.readText) throw new Error("无法读取剪贴板，请长按输入框手动粘贴。");
  return navigator.clipboard.readText();
}

export async function writeClipboardText(text: string): Promise<void> {
  if (await androidClipboard()) {
    const { invoke } = await import("@tauri-apps/api/core");
    await invoke("plugin:clipboard-manager|write_text", { text });
    return;
  }
  if (!navigator.clipboard?.writeText) throw new Error("无法写入剪贴板，请选中文字后复制。");
  await navigator.clipboard.writeText(text);
}
